import config from "@config";

const currentTemplate = config.template.name || "base";

const routes = require(`../${currentTemplate}/router`);

export default routes.default;
